import React from 'react';
import "./MasterManagementPage.css";
import NavBar from '../../components/NavBar';
import { uploadData } from 'aws-amplify/storage';
import { useGeneralSetting } from '../../context/GeneralSettingContext';
import FanLoadingIcon from '../../components/FanLoadingIcon';
import { useSensorGroups } from '../../context/SensorGroupsContext';
import SensorGroupList from './components/SensorGroupList';
import ModifyGroupForm from './components/ModifyGroupForm';
import { useDialog } from '../../context/DialogContext';
import { apiCreateGroup, apiDeleteGroup, apiUpdateGroup } from '../../apis/SensorApi';
import { DIALOG_ERROR_GENERAL_ERROR_MESSAGE, DIALOG_MESSAGE_CONFIRM_DELETE_GROUP, DIALOG_MESSAGE_CONFIRM_DELETE_NOTIFICATION, DIALOG_MESSAGE_CREATED_NOTIFICATION_SUCCESSFULLY, DIALOG_MESSAGE_UPDATED_GENERAL_SETTING_SUCCESSFULLY, DIALOG_MESSAGE_UPDATED_NOTIFICATION_SUCCESSFULLY, TEXT_CREATE_NEW, TEXT_MASTER_MANAGEMENT, TEXT_MESSAGE_MANAGEMENT, TEXT_NOTIFICATION_MANAGEMENT } from 'constants/message';
import ModifyGeneralSettingForm from './components/ModifyGeneralSettingForm';
import NotificationList from './components/NotificationList';
import { useNotifications } from 'context/NotificationContext';
import { apiCreateNotification, apiDeleteNotification, apiUpdateNotification } from 'apis/NotificationApi';
import ModifyNotificationForm from './components/ModifyNotificationForm';

const TAB_GENERAL = '一般';
const TAB_MESSAGE = TEXT_MESSAGE_MANAGEMENT;
const TAB_NOTIFICATION = TEXT_NOTIFICATION_MANAGEMENT;
const TABS = [TAB_GENERAL, TAB_MESSAGE, TAB_NOTIFICATION];


const propTypes = {};
const defaultProps = {};
const MasterManagementPage = (props) => {
  /*** States and Variables ***/
  const { error, success, warningConfirm } = useDialog();
  const [loading, setLoading] = React.useState(false);
  const [tab, setTab] = React.useState(TAB_GENERAL);
  const { generalSetting, setGeneralSetting } = useGeneralSetting();
  const { sensorGroups } = useSensorGroups();
  const { notifications } = useNotifications()
  const [modifyingGroup, setModifyingGroup] = React.useState(null);
  const [modifyingNotification, setModifyingNotification] = React.useState(null);

  /*** Processing ***/
  /*** Sub Components ***/
  const renderGeneralSetting = () => {
    return <ModifyGeneralSettingForm
      initSetting={generalSetting || {}}
      onSubmit={onUpdateGeneralSetting} />
  }

  const renderGroupSetting = () => {
    return <div
      style={{ padding: modifyingGroup ? '0 16px' : '0' }}
      className='master_management_page_subnav_content_container'>
      {renderCreateGroupForm()}
    </div>
  }

  const renderCreateGroupForm = () => {
    if (modifyingGroup) {
      return <ModifyGroupForm
        group={modifyingGroup}
        onCancel={() => { setModifyingGroup(null) }}
        onModify={onModifyGroup} />
    }
    return <>
      <div
        style={{ justifyContent: 'flex-end' }}
        className='master_management_page_list_actions_container'>
        <button
          className='button_active'
          onClick={() => { setModifyingGroup({}) }}>
          {TEXT_CREATE_NEW}
        </button>
      </div>
      <div className='master_management_page_list_container'>
        <SensorGroupList
          items={sensorGroups}
          onClick={(item) => { setModifyingGroup(item) }}
          onDelete={onDeleteGroup} />
      </div>
    </>
  }

  const renderNotification = () => {
    return <div style={{ padding: modifyingNotification ? '0 16px' : '0' }}
      className='master_management_page_subnav_content_container'>
      {modifyingNotification ? (
        <ModifyNotificationForm
          notification={modifyingNotification}
          onCancel={() => setModifyingNotification(null)}
          onModify={onModifyNotification}
        />
      ) : (
        <>
          <div
            style={{ justifyContent: 'flex-end' }}
            className='master_management_page_list_actions_container'>
            <button
              className='button_active'
              onClick={() => { setModifyingNotification({}) }}>
              {TEXT_CREATE_NEW}
            </button>
          </div>
          <div className='master_management_page_list_container'>
            <NotificationList
              items={notifications}
              onClick={(item) => { setModifyingNotification(item) }}
              onDelete={onDeleteNotification} />
          </div>
        </>
      )}
    </div>
  }

  /*** Event Handlers ***/
  const onUpdateGeneralSetting = async (data) => {
    if (!loading) {
      setLoading(true);
      try {
        await uploadData({
          key: 'setting/general_setting.json',
          data: JSON.stringify(data),
          options: {
            level: "public",
            contentType: "text/plain",
          }
        }).result;
        setGeneralSetting(data);
        success(DIALOG_MESSAGE_UPDATED_GENERAL_SETTING_SUCCESSFULLY);
      }
      catch (e) {
        error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
      }
      setLoading(false);
    }
  }
  const onModifyGroup = async (newGroup) => {
    if (!newGroup.name) {
      error("グループ名を入力していません！");
      return;
    }
    if (!loading) {
      setLoading(true);
      if (!modifyingGroup.id) {
        const result = await apiCreateGroup(newGroup);
        if (result.success) {
          success("センサグループを作成しました。");
          setModifyingGroup(null);
        }
        else {
          error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
        }
      }
      else {
        delete newGroup.updatedAt;
        delete newGroup.createdAt;
        const result = await apiUpdateGroup(newGroup);
        if (result.success) {
          success("センサグループを更新しました。");
          setModifyingGroup(null);
        }
        else {
          error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
        }
      }
      setLoading(false);
    }
  }

  const onDeleteGroup = async (item) => {
    warningConfirm(DIALOG_MESSAGE_CONFIRM_DELETE_GROUP, async () => {
      const result = await apiDeleteGroup(item.id);
      if (!result.success) {
        error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
      }
    }, {});
  }

  const onModifyNotification = async (newNotification) => {
    if (!loading) {
      setLoading(true);
      if (!modifyingNotification.id) {
        const result = await apiCreateNotification(newNotification);
        if (result.success) {
          success(DIALOG_MESSAGE_CREATED_NOTIFICATION_SUCCESSFULLY);
          setModifyingNotification(null);
        }
        else {
          error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
        }
      }
      else {
        delete newNotification.updatedAt;
        delete newNotification.createdAt;
        const result = await apiUpdateNotification(newNotification);
        if (result.success) {
          success(DIALOG_MESSAGE_UPDATED_NOTIFICATION_SUCCESSFULLY);
          setModifyingNotification(null);
        }
        else {
          error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
        }
      }
      setLoading(false);
    }
  }

  const onDeleteNotification = async (item) => {
    warningConfirm(DIALOG_MESSAGE_CONFIRM_DELETE_NOTIFICATION, async () => {
      const result = await apiDeleteNotification(item.id);
      if (!result.success) {
        error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
      }
    }, {});
  }
  /*** Main Render ***/
  return <div className='master_management_page_container'>
    <div className='master_header'>
      <label className='header-text' style={{ fontWeight: 900 }}>{TEXT_MASTER_MANAGEMENT}</label>
      <NavBar
        tabs={TABS}
        currentTab={tab}
        onTabChange={setTab} />
      <label className='master_management_page_version'>Version 1.6</label>
    </div>

    <div className='master_management_page_nav_content'>
      {tab === TAB_GENERAL ? renderGeneralSetting() : tab === TAB_MESSAGE ? renderGroupSetting() : renderNotification()}
    </div>
    {loading ? <FanLoadingIcon size={80} /> : null}
  </div>;
}
MasterManagementPage.propTypes = propTypes;
MasterManagementPage.defaultProps = defaultProps;
export default MasterManagementPage;